var map = {
	"./coin-BTC.svg": "a3e8",
	"./coin-CCF.svg": "bff0",
	"./coin-CRO.svg": "5b84",
	"./coin-DASH.svg": "3bf9",
	"./coin-ETH.svg": "2f9b",
	"./coin-LTC.svg": "b95d",
	"./coin-XRP.svg": "abaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0991";